import { StudentContext } from "context/StudentContext";
import { useContext } from "react";

function useStudentContext() {
    return useContext(StudentContext);
}

export default useStudentContext;